/**
 * Mobile bottom tabbar. One row of all 7 apps; the active one's
 * icon + label is tinted with its accent.
 */

import { NavLink } from "react-router-dom";

import { useT } from "../lib/i18n";
import { APPS, appPathOf } from "./apps";

export function MobileTabbar(): JSX.Element {
  const [, T] = useT();
  return (
    <div className="vz-tabbar">
      {APPS.map((app) => {
        const Ico = app.icon;
        return (
          <NavLink
            key={app.id}
            to={appPathOf(app.id)}
            className={({ isActive }) =>
              "vz-tab" + (isActive ? " active" : "")
            }
            style={({ isActive }) =>
              isActive
                ? { ["--app-accent" as string]: `var(${app.tint})` }
                : undefined
            }
          >
            <Ico />
            <span>{T(app.i18nKey)}</span>
          </NavLink>
        );
      })}
    </div>
  );
}
